import {
  FETCH_ASSESSMENT,
  FETCH_ASSESSMENT_SUCCESS,
  FETCH_ASSESSMENT_FAILURE,
  FETCH_ASSESSMENTS,
  FETCH_ASSESSMENTS_SUCCESS,
  FETCH_ASSESSMENTS_FAILURE,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_FAILURE,
  COUNT_ASSESSMENTS,
  COUNT_ASSESSMENTS_SUCCESS,
  COUNT_ASSESSMENTS_FAILURE,
  CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_FAILURE,
} from "./actionTypes";

import {
  errorMetaData,
  pendingMetaData,
  successMetaData,
} from "@workspace/common";

const initialState = {
  assessments: [],
  assessment: {},
  assessmentCount: null,
  createMeta: {},
  updateMeta: {},
  deleteMeta: {},
  uploadMeta: {},
};

const AssessmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSESSMENTS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        assessments: action.payload,
      };
    case FETCH_ASSESSMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_ASSESSMENT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        assessment: action.payload,
      };
    case FETCH_ASSESSMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_ASSESSMENT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        assessment: action.payload,
      };
    case DELETE_ASSESSMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Count Assessments
    case COUNT_ASSESSMENTS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case COUNT_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        assessmentCount: action.payload,
      };
    case COUNT_ASSESSMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_ASSESSMENT:
      return {
        ...state,
        createMeta: pendingMetaData(),
      };

    case CREATE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        createMeta: successMetaData(),
      };

    case CREATE_ASSESSMENT_FAILURE:
      return {
        ...state,
        createMeta: errorMetaData(action.payload),
      };
    default:
      return state;
  }
};

export default AssessmentsReducer;
